"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../../hooks");
var _A = require("../../../UI/A");
var _PurchaseButton = require("./Partials/PurchaseButton");
var _LoginButton = require("./Partials/LoginButton");
var _Profile = require("./Partials/Profile");
var _Notifications = require("./Partials/Notifications");
var _LangSelection = require("./Partials/LangSelection");
var _Header = require("./Header.labels");
var _Header2 = _interopRequireDefault(require("./Header.styles"));
var _LogoOfekHE = _interopRequireDefault(require("./resources/LogoOfekHE.svg"));
var _LogoOfekAR = _interopRequireDefault(require("./resources/LogoOfekAR.svg"));
var _LogoOfekEN = _interopRequireDefault(require("./resources/LogoOfekEN.svg"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Header = props => {
  const {
    logoUrl,
    logoLink,
    avatarUrl,
    avatarSize,
    isShowLogin,
    isShowNotifications,
    lang,
    langs,
    notifications,
    children,
    purchaseButtonGuestLabel,
    purchaseButtonGuestHref,
    purchaseButtonLabel,
    purchaseButtonHref,
    supportButtonLabel,
    supportButtonHref = '',
    onLanguageChange,
    onShowProfileClick,
    headerAttributes
  } = props;
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const user = (0, _hooks.useSessionData)();
  const getLabel = (0, _hooks.useLabels)({
    labels: _Header.labels
  });
  const styles = (0, _Header2.default)(isMobileView, !Boolean(user?.userId));
  const siteLogo = (0, _react.useMemo)(() => ({
    he: _LogoOfekHE.default,
    ar: _LogoOfekAR.default,
    en: _LogoOfekEN.default
  }), []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("header", {
    className: styles['cc-Header'],
    ...headerAttributes,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: styles['cc-Header__logo'],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
        to: logoLink ? logoLink : `/${lang}`,
        target: "_top",
        customStyle: styles['cc-Header__logo__link'],
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: logoUrl ?? siteLogo[lang],
          alt: getLabel('cet')
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-Header__toolbar'],
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PurchaseButton.PurchaseButton, {
        isMobileView: isMobileView,
        user: user,
        purchaseButtonGuestLabel: purchaseButtonGuestLabel,
        purchaseButtonGuestHref: purchaseButtonGuestHref,
        purchaseButtonLabel: purchaseButtonLabel,
        purchaseButtonHref: purchaseButtonHref
      }), !isMobileView && supportButtonLabel && supportButtonHref && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
          to: supportButtonHref,
          target: "_blank",
          color: "primary",
          category: "upperToolbar",
          label: "support",
          shape: "roundedRectangle",
          view: "outlined",
          isBtnView: true,
          ariaLabel: supportButtonLabel,
          children: supportButtonLabel
        })
      }), !isMobileView && (children || isShowNotifications || !user?.userId) && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: styles['cc-Header__toolbar__spacer']
      }), children, isShowNotifications && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Notifications.Notifications, {
        isMobileView: isMobileView,
        user: user,
        notifications: notifications
      }), !isMobileView && user?.userId && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: styles['cc-Header__toolbar__spacer']
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Profile.Profile, {
        isMobileView: isMobileView,
        lang: lang,
        avatarUrl: avatarUrl,
        avatarSize: avatarSize,
        user: user,
        onShowProfileClick: onShowProfileClick
      }), isShowLogin && /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoginButton.LoginButton, {
        isMobileView: isMobileView,
        user: user
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LangSelection.LangSelection, {
        isMobileView: isMobileView,
        user: user,
        lang: lang,
        langs: langs,
        onLanguageChange: onLanguageChange
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-Header__TopMarker'],
      "data-scrolling-handler-element": "headerTopMarker"
    })]
  });
};
exports.Header = Header;